import React from 'react'
import { Link } from 'react-router-dom'

function Wishlist() {
  return (
    <div>
    <div className="breadcrumb-row">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="d-flex justify-content-between align-items-center breadcrumb-item">
                            <div className="breadcrumb-title-heading">
                                <h1 className="title">Wishlist</h1>
                            </div>
                            <div className="breadcrumb-wrapper">
                                <span className="mr-1"><i className="ti ti-home"></i></span>
                                <Link title="Homepage" to="/">Home</Link>
                                <span className="ttm-bread-sep">&nbsp;/&nbsp;</span>
                                <span className="ttm-textcolor-skincolor">Wishlist</span>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>                    
        </div>
    
    {/* <!-- Section Start --> */}
    <section className="section">
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="table-responsive cart_table">
                        <table>
                            <thead>
                                <tr>
                                    <th className="remove-item"></th>
                                    <th>Product</th>
                                    <th>Price</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="remove">
                                        <button className="remove-from-cart" type="button">
                                            <span></span>
                                            <span></span>
                                        </button>
                                    </td>
                                    <td>
                                        <div className="cart_product">
                                            <img src="/tm/react/toolways/assets/images/product/grid/1.png" className="image-fit-contain" alt="img"/>
                                            <div className="cart_product_text">
                                                <h6 className="title">
                                                    <Link to="/shop-details">Power Drill</Link>
                                                </h6>
                                                <p className="mb-0">Drill</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <strong>$275.00</strong>
                                    </td>
                                    <td>
                                        <span className="badge badge-success">In Stock</span>
                                    </td>
                                    <td>
                                        <button type="button" className="thm-btn btn-rectangle thm-bg-color-one lh-normal btn-small">Add To Cart</button>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="remove">
                                        <button className="remove-from-cart" type="button">
                                            <span></span>
                                            <span></span>
                                        </button>
                                    </td>
                                    <td>
                                        <div className="cart_product">
                                            <img src="/tm/react/toolways/assets/images/product/grid/2.png" className="image-fit-contain" alt="img"/>
                                            <div className="cart_product_text">
                                                <h6 className="title">
                                                    <Link to="/shop-details">Battery Drill</Link>
                                                </h6>
                                                <p className="mb-0">Drill</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <strong>$170.00</strong>
                                    </td>
                                    <td>
                                        <span className="badge badge-success">In Stock</span>
                                    </td>
                                    <td>
                                        <button type="button" className="thm-btn btn-rectangle thm-bg-color-one lh-normal btn-small">Add To Cart</button>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="remove">
                                        <button className="remove-from-cart" type="button">
                                            <span></span>
                                            <span></span>
                                        </button>
                                    </td>
                                    <td>
                                        <div className="cart_product">
                                            <img src="/tm/react/toolways/assets/images/product/grid/3.png" className="image-fit-contain" alt="img"/>
                                            <div className="cart_product_text">
                                                <h6 className="title">
                                                    <Link to="/shop-details">Hammer Drill</Link>
                                                </h6>
                                                <p className="mb-0">Drill</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <strong>$385.00</strong>
                                    </td>
                                    <td>
                                        <span className="badge badge-danger">Out Of Stock</span>
                                    </td>
                                    <td>
                                        <button type="button" className="thm-btn btn-rectangle thm-bg-color-one lh-normal btn-small" disabled>Add To Cart</button>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="remove">
                                        <button className="remove-from-cart" type="button">
                                            <span></span>
                                            <span></span>
                                        </button>
                                    </td>
                                    <td>
                                        <div className="cart_product">
                                            <img src="/tm/react/toolways/assets/images/product/grid/4.png" className="image-fit-contain" alt="img"/>
                                            <div className="cart_product_text">
                                                <h6 className="title">
                                                    <Link to="/shop-details">Circular Grinder</Link>
                                                </h6>
                                                <p className="mb-0">Grinder</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <strong>$200.00</strong>
                                    </td>
                                    <td>
                                        <span className="badge badge-danger">Out Of Stock</span>
                                    </td>
                                    <td>
                                        <button type="button" className="thm-btn btn-rectangle thm-bg-color-one lh-normal btn-small" disabled>Add To Cart</button>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="remove">
                                        <button className="remove-from-cart" type="button">
                                            <span></span>
                                            <span></span>
                                        </button>
                                    </td>
                                    <td>
                                        <div className="cart_product">
                                            <img src="/tm/react/toolways/assets/images/product/grid/5.png" className="image-fit-contain" alt="img"/>
                                            <div className="cart_product_text">
                                                <h6 className="title">
                                                    <Link to="/shop-details">Electrical Grinder</Link>
                                                </h6>
                                                <p className="mb-0">Grinder</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <strong>$80.00</strong>
                                    </td>
                                    <td>
                                        <span className="badge badge-success">In Stock</span>
                                    </td>
                                    <td>
                                        <button type="button" className="thm-btn btn-rectangle thm-bg-color-one lh-normal btn-small">Add To Cart</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default Wishlist